
const getDataLSObj = () => {
  const respaldoAtenciones = localStorage.getItem("respaldoAtenciones");
  if(!respaldoAtenciones) return null;
  const dataObj = JSON.parse(respaldoAtenciones);
  return dataObj
}



export const loadRespaldo = (identificador = null, field = '') => {

  if(!identificador || !field) {
    console.error("identificador y field son requeridos");
    return null;
  }

  const respaldoObj = getDataLSObj();
  if(!respaldoObj) return null;

  const respaldoSearch = respaldoObj.find( respaldo => respaldo.identificador === identificador)
  if(!respaldoSearch) return null;

  console.log("LOAD RESPALDO", respaldoSearch)

  return respaldoSearch[field] ?? null;
}



export const saveRespaldo = (identificador = null, field = '', value = null) => {

  if(!identificador || !field) {
    console.error("identificador, field y value son requeridos");
    return null;
  }

  let respaldoAtenciones = localStorage.getItem("respaldoAtenciones");

  if(!respaldoAtenciones) {
    const respaldoActual = [{ identificador, [field]: value }];
    localStorage.setItem("respaldoAtenciones", JSON.stringify(respaldoActual));
    respaldoAtenciones = localStorage.getItem("respaldoAtenciones");
  }

  const respaldosObj = JSON.parse(respaldoAtenciones);
  const respaldoSearch = respaldosObj?.find( respaldo => respaldo.identificador === identificador);

  if(!respaldoSearch) {
    respaldosObj.push({ identificador, [field]: value });
  }

  const respaldoSearchIndex = respaldosObj.findIndex( respaldo => respaldo.identificador === identificador);
  respaldosObj[respaldoSearchIndex][field] = value;
  respaldosObj[respaldoSearchIndex].lastUpdate = new Date();

  console.log("RESPALDO ATENCIONES", respaldosObj)

  localStorage.setItem("respaldoAtenciones", JSON.stringify(respaldosObj));

}



export const deleteRespaldoAtencion = (identificador) => {

  if(!identificador){
    console.error("identificador es requerido");
    return;
  }

  const respaldoAtencionesObj = getDataLSObj();
  if(!respaldoAtencionesObj) return;

  const respaldoSearchIndex = respaldoAtencionesObj.findIndex( respaldo => respaldo.identificador === identificador);
  if(respaldoSearchIndex === -1) return;

  respaldoAtencionesObj.splice(respaldoSearchIndex, 1);
  localStorage.setItem("respaldoAtenciones", JSON.stringify(respaldoAtencionesObj));
}
